/** Dansk dato til nyheder og lister */
export function formatDateShort(iso) {
  if (!iso) return ''
  const d = new Date(iso)
  const now = new Date()
  const diff = Math.floor((now - d) / (1000 * 60 * 60 * 24))
  if (diff === 0) return 'I dag'
  if (diff === 1) return 'I går'
  if (diff < 7) return `${diff} dage siden`
  return d.toLocaleDateString('da-DK', { day: 'numeric', month: 'short' })
}

export function formatDateLong(iso) {
  if (!iso) return ''
  return new Date(iso).toLocaleDateString('da-DK', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  })
}
